/* eslint-disable import/prefer-default-export */
import i18n from 'i18next';
import { ColDef, ValueFormatterParams } from '@ag-grid-enterprise/all-modules';
import { stateValueFormatter } from 'utils/valueFormatters';
import GridGroupHeader from 'components/GridGroupHeader';

export const fqdnGroupColumnDef: ColDef = {
    headerName: i18n.t('fqdn.grid.domainGroup'),
    sortable: true,
    floatingFilter: true,
    filter: 'agTextColumnFilter',
    resizable: true,
    flex: 1,
    minWidth: 220,
    headerComponent: GridGroupHeader as any,
    filterValueGetter: (params: Partial<ValueFormatterParams>): string => params.data?.name,
};

export const fqdnColumnDefs: ColDef[] = [
    {
        headerName: '',
        field: 'fsId',
        rowGroup: true,
        hide: true,
        sortable: true,
        lockVisible: true,
        floatingFilter: true,

    },
    {
        headerName: i18n.t('fqdn.grid.domainName'),
        field: 'domainName',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        filterParams: {
            buttons: ['clear', 'apply'],
        },
        resizable: true,
        tooltipField: 'name',
        flex: 1,
        minWidth: 198,
    },
    {
        headerName: i18n.t('fqdn.grid.currentState'),
        field: 'state',
        sortable: true,
        filter: 'agSetColumnFilter',
        floatingFilter: true,
        resizable: true,
        flex: 1,
        minWidth: 132,
        valueFormatter: stateValueFormatter,
    },
];

export const fqdnViewDomainDefs: ColDef[] = [
    {
        headerName: i18n.t('fqdn.grid.domainName'),
        field: 'domainName',
        sortable: false,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        filterParams: {
            buttons: ['clear', 'apply'],
        },
        resizable: true,
        tooltipField: 'name',
        flex: 1,
        minWidth: 198,
    },
    {
        headerName: i18n.t('fqdn.grid.currentState'),
        field: 'state',
        sortable: false,
        filter: 'agSetColumnFilter',
        floatingFilter: true,
        resizable: true,
        flex: 1,
        minWidth: 132,
        valueFormatter: stateValueFormatter,
    },
]

export const fqdpDomainColumnDefs: ColDef[] = [
    {
        headerName: i18n.t('fqdn.grid.domainName'),
        field: 'domainName',
        flex: 2,
        filter: 'agTextColumnFilter',
        editable: true,
        cellRenderer: 'domainNameCellRenderer',
    },
    {
        filter: false,
        cellClass: 'allowed-ips-update-table-center-cell',
        headerClass: 'allowed-ips-update-table-action-header',
        cellRenderer: 'actionCellRenderer',
    },
];
